import { createRootRoute, Outlet, redirect, useLocation } from '@tanstack/react-router';
import { ClipboardList, Globe, Home, LogOut, Menu, Settings, Trophy, Users } from 'lucide-react';
import { DashboardLayout, NavItem, type DashboardProfile } from '../components/dashboard';
import { NavLink, ProfileNavItem } from '@/components/common';
import { auth } from '@/auth';
import { useSession } from 'ht-sdk/auth/client';

export const Route = createRootRoute({
	beforeLoad: async ({ location }) => {
		let session;

		// NOTE: we get the session here because we need it both for non-public routes and login
		// it's excessive for other non-public routes, but it also only re-fetches when our access token actually expired
		// so it's not a big deal
		session = await auth.getValidAccessToken();

		// always allow access to onboarding route
		if (location.pathname.startsWith('/onboarding')) return;
		if (location.pathname.startsWith('/forgot-password')) return;

		if (!location.pathname.startsWith('/login') && !session) {
			console.log('redirecting to login');
			throw redirect({ to: '/login' });
		}

		console.log('session', session);
		console.log(location.pathname);

		if (!location.pathname.startsWith('/dashboard') && session) {
			console.log('redirecting to dashboard');
			throw redirect({ to: '/dashboard' });
		}
	},
	component: RootLayout,
});

function RootLayout() {
	const loc = useLocation();

	const isDashboardRoute = loc.pathname.startsWith('/dashboard');

	if (isDashboardRoute) {
		return <DashboardLayout2 />;
	} else {
		return <Outlet />;
	}
}

function DashboardLayout2() {
	const location = useLocation();

	const session = useSession(auth);

	const isAdmin = session?.role == 'admin';

	const isActive = (path: string) => (path === '/dashboard' ? location.pathname === '/dashboard' : location.pathname.startsWith(path));

	const profile: DashboardProfile = {
		id: session?.id ?? '',
		name: session?.name ?? '',
		avatarUrl: session?.avatarUrl,
	};

	return (
		<DashboardLayout menuIcon={Menu}>
			<DashboardLayout.ProfileNavItem>{profile && <ProfileNavItem profile={profile} />}</DashboardLayout.ProfileNavItem>
			<DashboardLayout.NavItemsTop>
				<NavLink to="/dashboard" name="Dashboard" icon={Home} active={isActive('/dashboard')} />
				<NavLink to="/dashboard/locations" name="Locations" icon={Globe} active={isActive('/dashboard/locations')} />
				<NavLink to="/dashboard/ranking" name="Ranking" icon={Trophy} active={isActive('/dashboard/ranking')} />
				{isAdmin && <NavLink to="/dashboard/rooms" name="Rooms" icon={ClipboardList} active={isActive('/dashboard/rooms')} />}
				{isAdmin && <NavLink to="/dashboard/settings" name="Settings" icon={Settings} active={isActive('/dashboard/settings')} />}
				{isAdmin && <NavLink to="/dashboard/users" name="Users" icon={Users} active={isActive('/dashboard/users')} />}
			</DashboardLayout.NavItemsTop>
			<DashboardLayout.NavItemsBottom>
				<NavItem
					as={'button'}
					name="Sign Out"
					icon={LogOut}
					type="button"
					onClick={() => {
						auth.logout();
					}}
				/>
			</DashboardLayout.NavItemsBottom>
			<Outlet></Outlet>
		</DashboardLayout>
	);
}
